import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { Refresh } from 'components/lib/DesignSystem/Icons'

class ErrorContainer extends React.Component {
  render() {
    const { error, className } = this.props

    return (
      <Container className={className}>
        <Title>{error.title}</Title>
        <Detail>{error.detail}</Detail>
        {error && error.refreshAction && (
          <Action>
            <Refresh title="Refresh" onClick={error.refreshAction} />
          </Action>
        )}
      </Container>
    )
  }
}

ErrorContainer.propTypes = {
  error: PropTypes.shape({
    title: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    detail: PropTypes.string.isRequired,
    refreshAction: PropTypes.func,
  }).isRequired,
}

const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

const Title = styled.div`
  color: var(--red);
  font-size: 44px;
`

const Detail = styled.div`
  color: var(--red);
  font-size: 14px;
`

const Action = styled.div`
  margin-top: 15px;
  i {
    font-size: 20px;
  }
`

export default ErrorContainer
